// Single source of the short definitions surfaced as InfoTips on the report.
//
// The criteria and 4D wording mirrors the server scoring config (agent/scoring-config.json:
// criteria ~15-21, 4D ~23-38) and the 4D descriptors already in Report.tsx (FOURD_DESC). The
// copy is duplicated here on purpose: the frontend must not import the server config directly.
// The "Fluency velocity" definition is not in scoring-config.json (it only lists low/medium/
// high), so it is product copy written for the report.
import type { CriterionKey, FourDKey } from './types';

// What each of the five capability criteria measures. One or two plain sentences.
export const CRITERION_DEF: Record<CriterionKey, string> = {
  prompt_mastery:
    'How clearly and precisely you ask AI for what you need, including the context, format and constraints that get a useful first answer.',
  technical_understanding:
    'How well you grasp what these tools can and cannot do, so you pick the right one for a task and set realistic expectations.',
  practical_application:
    'How reliably you put AI to work on real tasks and get results you can use, not just experiments.',
  critical_evaluation:
    'How well you judge AI output: catching errors, checking claims and knowing when to trust a result and when to verify it.',
  workflow_design:
    'How deliberately you build AI into how work actually gets done, rather than reaching for it ad hoc.',
};

// What each 4D dimension describes (the "how you work with AI" model).
export const FOURD_DEF: Record<FourDKey, string> = {
  description:
    'Briefing AI clearly: giving it the context, examples and constraints it needs to do the job well.',
  delegation:
    'Handing whole tasks to AI and judging which work to keep for yourself.',
  discernment:
    'Reviewing what AI produces, spotting errors and deciding what is good enough to use.',
  diligence:
    'Working with care over time: versioning prompts, reusing what works and keeping a record.',
};

// "Fluency velocity" — not defined in scoring-config.json. Short product copy.
export const VELOCITY_DEF =
  'How quickly you are taking on new ways of working with AI. It tracks the pace of adoption, not how skilled you are, so a steady, deliberate pace is healthy.';
